import { useCallback } from "react";

import {
  Application,
  ApplicationLanguages,
  getApplicationLanguage,
  ProfileTypeName
} from "@platformsh/observability-graph/ContinuousProfiling";

import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { usePoller } from "src/organization/pages/project/environment/metrics/utils/polling";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

type Props = {
  application: Application | null | undefined;
  profileTypeName: ProfileTypeName | undefined;
  timeFrame?: TimeFrameType;
};

const useConprofFlamebearerPoll = ({
  application,
  profileTypeName,
  timeFrame
}: Props) => {
  const client = useObservabilityPipelineHttpClient();

  const applicationName = application?.name;
  const language =
    (application ? getApplicationLanguage(application) : null) ??
    ApplicationLanguages.UNKNOWN;

  const requestFn = useCallback(
    async timeFrame => {
      if (!profileTypeName || !applicationName || !timeFrame) {
        return;
      }

      if (client === null) return Promise.reject("Null value");
      return await client.getContinuousProfilingFlamebearerData({
        timeFrame,
        applicationName,
        language,
        profileTypeName
      });
    },
    [client, applicationName, language, profileTypeName]
  );

  return usePoller({
    requestFn,
    timeFrame
  });
};

export default useConprofFlamebearerPoll;
